const pbdsDividerContent = {
    init: () => {
        // console.log('pbdsDividerContent initialized!');

        
        
    }
}

window.loadedComponents.push({ component: 'pbds-divider--content', init: pbdsDividerContent.init});

export default () => {
    pbdsDividerContent.init();
}